import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { faCircleNotch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Input from 'components/input';
import { useSoldItems } from 'components/pages/campaign-settings/campaign-auction/sold-items/useSoldItems';
import * as Table from 'components/table';
import { IntercomProductTourTargets } from 'constants/intercom';

const SoldItems = () => {
    const {
        table,
        onSubmitExportReport,
        isGeneratingReport,
        search,
        setSearch,
        searchTerm,
        isPending,
    } = useSoldItems();

    const onExportClick = () => onSubmitExportReport();

    return (
        <div className={'flex flex-col gap-y-4'}>
            <h3
                data-intercom-target={IntercomProductTourTargets.AuctionWinningBidsTitle}
                className={'text-2xl font-medium'}
            >
                Winning bids
            </h3>
            <div className="flex justify-between">
                <div className={'flex items-center justify-between'}>
                    <Input.Root>
                        <Input.SearchIcon />
                        <Input.Form
                            placeholder={'Search'}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                    </Input.Root>
                </div>
                <Button
                    size={'sm'}
                    variant={'outline'}
                    color={'neutral'}
                    onClick={onExportClick}
                    disabled={isGeneratingReport}
                >
                    {isGeneratingReport ? (
                        <FontAwesomeIcon icon={faCircleNotch} className={'animate-spin'} />
                    ) : (
                        'Export sold items'
                    )}
                </Button>
            </div>
            <Table.Root
                isLoading={isPending}
                table={table}
                searchTerm={searchTerm}
                variant="bordered"
            >
                <Box className="overflow-x-auto">
                    <Table.Content>
                        <Table.Header />
                        <Table.Body />
                    </Table.Content>
                    <Table.Empty variant={'secondary'}>
                        <Table.EmptyIcon />
                        <Table.EmptyTitle>No winning bids found</Table.EmptyTitle>
                    </Table.Empty>
                </Box>
                <Table.Pagination>
                    <Table.PaginationPageNavigation />
                </Table.Pagination>
            </Table.Root>
        </div>
    );
};

export { SoldItems };
